module.exports = __webpack_public_path__ + "img/schnittkante_ultramarinblau_ral5002.698fc58d.jpg";